var map = {
	"./favicon.ico": 36,
	"./footer/en_ef": 15,
	"./footer/en_ef.svg": 15,
	"./footer/en_efs": 16,
	"./footer/en_efs.svg": 16,
	"./footer/en_rp": 17,
	"./footer/en_rp.svg": 17,
	"./footer/pl_ef": 18,
	"./footer/pl_ef.svg": 18,
	"./footer/pl_efs": 19,
	"./footer/pl_efs.svg": 19,
	"./footer/pl_rp": 20,
	"./footer/pl_rp.svg": 20,
	"./icons/gf-arrow_right-sharp": 21,
	"./icons/gf-arrow_right-sharp.svg": 21,
	"./logo_en": 22,
	"./logo_en.svg": 22,
	"./logo_pl": 23,
	"./logo_pl.svg": 23,
	"./logo_text_en": 24,
	"./logo_text_en.svg": 24,
	"./logo_text_pl": 25,
	"./logo_text_pl.svg": 25
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;